import { withValueVersion } from "../withValueVersion";
import { BackendResponse } from "../BackendResponse";
import { getNextApiUrl } from "../getNextApiUrl";

export interface GetJobPictureUrlResponse extends BackendResponse {
  url: string;
}

export interface GetJobPictureUrlParameters {
  konsernid: number;
  typeRelated: number;
  idRelated: number;
  idDocument: number;
}

export type getJobPictureUrl = (
  args: GetJobPictureUrlParameters
) => GetJobPictureUrlResponse;

export const getJobPictureUrl: getJobPictureUrl = withValueVersion((args) => {
  const { idDocument, typeRelated, konsernid, idRelated } = args;

  const base = getNextApiUrl("/cvp/cvpviewjobpicture");
  const url = `${base}?idDocument=${idDocument}&typeRelated=${typeRelated}&idRelated=${idRelated}&idConcern=${konsernid}`;

  return {
    url,
    ok: true,
    elapsedMilliseconds: 0,
    statusCode: 1200,
  };
}, false);
